import Form from "./Form.vue";

export default {
  computed: {
    parentForm() {
      let parent = this.$parent;
      for (let i = 0; i < 10; i++) {
        if (parent == null) {
          throw new Error(`A fieldset component must be in a ${Form.name} component`);
        }
        if (parent.$options.name == Form.name) {
          return parent;
        }
        parent = parent.$parent;
      }
      return null;
    },
    form() {
      if (!this.parentForm) {
        return null;
      }

      return this.parentForm.data;
    }
  }
};
